export const distinctBy = <T>(items: Array<T>, projection: (x: T) => string | number): Array<T> =>
	(items || ([] as Array<T>)).reduce(
		([a, s]: [Array<T>, Set<string | number>], c: T): [Array<T>, Set<string | number>] => {
			if (s.has(projection(c))) {
				return [a, s];
			}

			s.add(projection(c));

			return [[c, ...a], s];
		},
		[[], new Set<string | number>()]
	)[0];
